<template>
    <div class="project-tree">
      <v-list dense class="pa-0">
        <div v-for="project in projectCrawlings" :key="project.id" class="project-item">
          <v-list-item class="pl-0">
            <v-list-item-content>
              <div class="d-flex align-center py-1">
                <!-- Plus button for expansion - only show if there are crawling jobs -->
                <v-btn
                  v-if="project.crawling_jobs?.length"
                  icon
                  x-small
                  class="mr-1"
                  @click.stop="toggleProject(project.id)"
                >
                  <v-icon small>
                    {{ expandedProjects.includes(project.id) ? 'mdi-minus' : 'mdi-plus' }}
                  </v-icon>
                </v-btn>
                <v-icon small class="mr-2">mdi-folder</v-icon>
                <!-- Project name - clickable for modal -->
                <span 
                  class="project-name"
                  @click="openProjectDetail(project)"
                >
                  {{ formatProjectName(project) }}
                </span>
              </div>
            </v-list-item-content>
          </v-list-item>
          
          <div v-if="expandedProjects.includes(project.id) && project.crawling_jobs?.length" 
               class="crawling-jobs ml-8">
            <div v-for="job in project.crawling_jobs" 
                 :key="job.id" 
                 class="crawling-job-item d-flex align-center py-1">
              <v-checkbox
                v-model="selectedJobs"
                :value="job"
                dense
                hide-details
                class="mr-2"
              ></v-checkbox>
              <v-icon small class="mr-2">mdi-file-outline</v-icon>
              <span class="caption">{{ formatCrawlingJob(job) }}</span>
            </div>
          </div>
        </div>
      </v-list>
  
      <!-- Project Detail Modal -->
      <project-detail-modal
        v-model="showModal"
        :project-data="selectedProject"
        @close="closeModal"
      />
    </div>
  </template>
  
  <script>
  import ProjectDetailModal from './ProjectDetailModal.vue'
  
  export default {
    name: 'ProjectTreeView',
    
    components: {
      ProjectDetailModal
    },
  
    props: {
      projectCrawlings: {
        type: Array,
        required: true,
        default: () => []
      }
    },
  
    emits: ['project-selected', 'create-chat'],
  
    data() {
      return {
        expandedProjects: [],
        selectedJobs: [],
        showModal: false,
        selectedProject: null
      }
    },
    
    methods: {
      formatProjectName(project) {
        const startYear = new Date(project.start_date).getFullYear()
        return `${project.name}_${startYear}_PM`
      },
  
      formatCrawlingJob(job) {
        const requesterId = job.lucy_path.split('/')[0]
        const startDate = new Date(job.created_at)
        const formattedDate = `${startDate.getFullYear()}.${String(startDate.getMonth() + 1).padStart(2, '0')}.${String(startDate.getDate()).padStart(2, '0')}`
        const status = job.status === 'completed' ? 'success' : 
                      job.status === 'error' ? 'failure' : 
                      'in_progress'
  
        return `${requesterId}_${formattedDate}_${status}`
      },
  
      toggleProject(projectId) {
        const index = this.expandedProjects.indexOf(projectId)
        if (index === -1) {
          this.expandedProjects.push(projectId)
        } else {
          this.expandedProjects.splice(index, 1)
        }
      },
  
      openProjectDetail(project) {
        this.$emit('project-selected', project)
      },
  
      closeModal() {
        this.showModal = false
        this.selectedProject = null
      },
  
      createChat() {
        if (this.selectedJobs.length === 0) {
          this.$store.commit('message/showMessage', {
            title: '오류',
            content: '크롤링 작업을 선택해주세요.'
          })
          return
        }
        
        this.$emit('create-chat', this.selectedJobs)
      },
  
      clearSelection() {
        this.selectedJobs = []
      }
    }
  }
  </script>
  
  <style scoped>
  .project-tree {
    background: white;
    border-radius: 4px;
    padding: 4px;
  }
  
  .project-item {
    cursor: default;
  }
  
  .project-name {
    cursor: pointer;
  }
  
  .project-name:hover {
    text-decoration: underline;
  }
  
  .crawling-jobs {
    cursor: default;
  }
  
  .crawling-job-item {
    font-size: 13px;
    color: #666;
    min-height: 28px;
  }
  
  :deep(.v-list-item) {
    min-height: 32px !important;
    padding: 0 8px !important;
  }
  
  :deep(.v-list-item__content) {
    padding: 0 !important;
  }
  
  :deep(.v-list) {
    padding: 0 !important;
  }
  
  :deep(.v-btn--icon.v-size--x-small) {
    width: 18px;
    height: 18px;
  }
  
  :deep(.v-btn--icon.v-size--x-small .v-icon) {
    font-size: 16px;
  }
  </style>
